import { PageProps } from '@/types';
import { Head } from "@inertiajs/react";
import React from "react";
import SupportLayout from './SupportPageLayout';
import ContactForm from "@/Pages/Support/ContactForm";
import useTranslations from '@/hooks/useTranslations';

export default function ContactPage({ auth }: PageProps) {
    const { __ } = useTranslations();
    return (
        <SupportLayout>
            <Head>
                <title>{__('contact.title')}</title>
                <meta name="description" content={__('contact.meta_description')} />
            </Head>
            {auth.user ?
                <div className="mt-6 lg:mt-12 lg:border-l lg:dark:border-gray-700 lg:ml-5">
                    <div className="container mx-auto sm:px-6 lg:px-8 space-y-6 lg:flex items-center justify-between">
                        <div className="p-4 lg:w-1/3 sm:p-8">
                            <header>
                                <h1 className="text-2xl lg:text-3xl text-gray-900 dark:text-gray-100 mb-5">{__('contact.page.title')}</h1>
                                <p className="mt-1 text-lg text-gray-600 dark:text-gray-400">{__('contact.page.description')}</p>
                            </header>
                        </div>
                        <div className="p-4 lg:w-1/2 sm:p-8 mx-4 lg:mx-0 bg-white dark:bg-gray-800 shadow rounded-lg">
                            <ContactForm user={auth.user} />
                        </div>
                    </div>
                </div>
                :
                <div className="container mx-auto py-12 px-4 sm:px-6 lg:px-8 lg:flex items-center justify-between">
                    <div className="p-4 lg:w-1/3 sm:p-8">
                        <h1 className="text-3xl mb-4 mt-4 text-gray-900 dark:text-gray-100">{__('contact.page.title')}</h1>
                        <p className="mt-1 text-base text-gray-600 dark:text-gray-400">{__('contact.page.description')}</p>
                    </div>

                    <div className="p-4 lg:w-1/2 sm:p-8 mx-4 lg:mx-0 bg-white dark:bg-gray-800 shadow-lg rounded-lg">
                        <ContactForm />
                    </div>
                </div>
            }
        </SupportLayout>
    )
}
